import React from 'react';
import './SpotifyPlayer.css';

function SpotifyPlayer() {
  return (
    <>
      {/* <div className="noBorder">
        <iframe
          style={{ borderRadius: '12px' }}
          src="https://open.spotify.com/embed/playlist/0Hm0IIv82NMm02ItS4Bd5?utm_source=generator"
          width="100%"
          height="352"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title="Spotify Playlist"
        ></iframe>
      </div> */}
      <div className="noBorder">
        <iframe
          style={{ borderRadius: '12px' }}
          src="https://open.spotify.com/embed/playlist/3caV4CB4zM2ETBxMWMMKbe?utm_source=generator"
          width="100%"
          height="352"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title="Spotify Playlist 2"
        ></iframe>
      </div>
    </>
  );
}

export default SpotifyPlayer;